import { useTranslation } from 'react-i18next'
import {
  Dropdown,
  Typography
} from 'antd'

const Language = () => {
  const { i18n } = useTranslation()

  const changeLanguage = (language: any) => {
    i18n.changeLanguage(language)
  }

  const Languages: any = {
    zh: { label: "CH", value: 'zh' },
    en: { label: "EN", value: 'en' },
    ja: { label: "JP", value: 'ja' },
  }

  return (
    <Dropdown
      destroyPopupOnHide={true}
      trigger={['click', 'hover']}
      overlayClassName='header-language-menu'
      menu={{
        items: Object.values(Languages).filter(
          (language: any) => language.value !== i18n.language
        ).map((language: any) => ({
          key: language.value,
          label: <div className='menu-item'>
            <Typography.Text>
              { language.label }
            </Typography.Text>
          </div>
        })),
        onClick: ({ item, key, keyPath, domEvent }) => {
          changeLanguage(key);
        }
      }}
      placement="bottom">
      <div className={"menu-item"}>
        <div className='content' style={{marginBottom: '1px'}}>
          <Typography.Text>
            { Languages[i18n.language]?.label }
          </Typography.Text>
        </div>
      </div>
    </Dropdown>
  )
}

export default Language